// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { GetAuthData, GetAuthResponse, GetCandlesData, GetCandlesResponse, GetSgManifestResponse, GetSgTnsContractsData, GetSgTnsContractsResponse, GetSgTnsFeedData, GetSgTnsFeedResponse, GetSgTnsFlowSumData, GetSgTnsFlowSumResponse, GetSgTnsHighlightsData, GetSgTnsHighlightsResponse, GetStreamData, GetValidateBearerResponse, GetVixQuoteData, GetVixQuoteResponse } from './types.gen';

export class DefaultService {
    /**
     * The handler for the auth request which generates a token to validate based on basic client
     * ID/secret authentication
     * @param data The data for the request.
     * @param data.authorization Basic Authentication
     * @returns string Success
     * @throws ApiError
     */
    public static getAuth(data: GetAuthData): CancelablePromise<GetAuthResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth',
            headers: {
                authorization: data.authorization
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.sym
     * @param data.stream
     * @param data.field
     * @param data.option
     * @param data.filter
     * @param data.order
     * @param data.limit
     * @param data.start
     * @param data.end
     * @returns string Success
     * @throws ApiError
     */
    public static getCandles(data: GetCandlesData): CancelablePromise<GetCandlesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/candles',
            query: {
                sym: data.sym,
                stream: data.stream,
                field: data.field,
                option: data.option,
                filter: data.filter,
                order: data.order,
                limit: data.limit,
                start: data.start,
                end: data.end
            }
        });
    }
    
    /**
     * The handler for the history request
     * @returns Manifest
     * @throws ApiError
     */
    public static getSgManifest(): CancelablePromise<GetSgManifestResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sg/manifest'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.sorting
     * @param data.offset
     * @param data.limit
     * @returns ContractRow Success
     * @throws ApiError
     */
    public static getSgTnsContracts(data: GetSgTnsContractsData = {}): CancelablePromise<GetSgTnsContractsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sg/tns_contracts',
            query: {
                filters: data.filters,
                sorting: data.sorting,
                offset: data.offset,
                limit: data.limit
            }
        });
    }
    
    /**
     * The handler for the Time & Sales feed
     * @param data The data for the request.
     * @param data.filters
     * @param data.sorting
     * @param data.offset
     * @param data.limit
     * @returns string Success
     * @throws ApiError
     */
    public static getSgTnsFeed(data: GetSgTnsFeedData = {}): CancelablePromise<GetSgTnsFeedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sg/tns_feed',
            query: {
                filters: data.filters,
                sorting: data.sorting,
                offset: data.offset,
                limit: data.limit
            }
        });
    }
    
    /**
     * The handler for the Time & Sales flow summary. Aggregate: volume, premium, delta, gamma, vega
     * @param data The data for the request.
     * @param data.filters
     * @returns HiroAggSummary Success
     * @throws ApiError
     */
    public static getSgTnsFlowSum(data: GetSgTnsFlowSumData = {}): CancelablePromise<GetSgTnsFlowSumResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sg/tns_flow_sum',
            query: {
                filters: data.filters
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.start
     * @param data.end
     * @returns Highlights Success
     * @throws ApiError
     */
    public static getSgTnsHighlights(data: GetSgTnsHighlightsData = {}): CancelablePromise<GetSgTnsHighlightsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sg/tns_highlights',
            query: {
                start: data.start,
                end: data.end
            }
        });
    }
    
    /**
     * The handler for the HTTP request (this gets called when the HTTP GET lands at the start
     * of websocket negotiation). After this completes, the actual switching from HTTP to
     * websocket protocol will occur.
     * This is the last point where we can extract TCP/IP metadata such as IP address of the client
     * as well as things from HTTP headers such as user-agent of the browser etc.
     * @param data The data for the request.
     * @param data.token
     * @throws ApiError
     */
    public static getStream(data: GetStreamData): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/stream',
            query: {
                token: data.token
            }
        });
    }
    
    /**
     * A simple handler for validating and inspecting a JWT token
     * @returns Claims Success
     * @throws ApiError
     */
    public static getValidateBearer(): CancelablePromise<GetValidateBearerResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/validate_bearer'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.dates
     * @returns Page_VixQuote Success
     * @throws ApiError
     */
    public static getVixQuote(data: GetVixQuoteData = {}): CancelablePromise<GetVixQuoteResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/vix_quote',
            query: {
                dates: data.dates
            }
        });
    }
    
}